// extracted by mini-css-extract-plugin
export default {"active":"GGroupBtn-module_active_e4dca3da"};